module.exports = __webpack_public_path__ + "static/11-99c80c523a414e4db90f38ebd95eab48.jpg";